import { DataTypeConfig } from "../../../../types";

export const facilitiesConfig: DataTypeConfig = {
  tabs: [
    "facilityType",
    "utilityService",
    "operatingStatus",
    "operationalHours",
    "serviceZone",
    "facilityManager",
    "depreciationSchedule",
  ],
  searchableColumns: [
    "Facility Name",
    "Facility Type",
    "Utility Service",
    "Operating Status",
    "Address/Site Label",
    "Service Zone/Division",
    "Facility Manager",
  ],
  filterColumns: [
    { column: "Facility Type", type: "dropdown", label: "Facility Type" },
    { column: "Utility Service", type: "dropdown", label: "Utility Service" },
    { column: "Operating Status", type: "dropdown", label: "Operating Status" },
    {
      column: "Service Zone/Division",
      type: "dropdown",
      label: "Service Zone/Division",
    },
    {
      column: "Commissioned Date",
      type: "date",
      label: "Commissioned Date",
    },
    {
      column: "Design Capacity (MLD)",
      type: "range",
      label: "Design Capacity (MLD)",
    },
    {
      column: "Annual O&M Budget",
      type: "range",
      label: "Annual O&M Budget",
    },
    {
      column: "Depreciation Schedule",
      type: "dropdown",
      label: "Depreciation Schedule",
    },
  ],
  tableColumns: [
    { key: "facilityName", header: "Facility Name", type: "custom" },
    { key: "facilityType", header: "Facility Type", type: "badge" },
    { key: "utilityService", header: "Utility Service", type: "badge" },
    { key: "operatingStatus", header: "Operating Status", type: "badge" },
    { key: "addressSiteLabel", header: "Address/Site Label", type: "custom" },
    { key: "serviceZone", header: "Service Zone/Division", type: "badge" },
    { key: "facilityManager", header: "Facility Manager", type: "badge" },
    {
      key: "depreciationSchedule",
      header: "Depreciation Schedule",
      type: "badge",
    },
    { key: "operationalHours", header: "Operational Hours", type: "badge" },
    { key: "latitude", header: "Latitude", type: "custom" },
    { key: "longitude", header: "Longitude", type: "custom" },
    { key: "designCapacity", header: "Design Capacity (MLD)", type: "custom" },
    { key: "commissionedDate", header: "Commissioned Date", type: "custom" },
    { key: "designUsefulLife", header: "Design Useful Life", type: "custom" },
    { key: "annualBudget", header: "Annual O&M Budget", type: "custom" },
  ],
  mandatoryFields: [
    "Facility Name",
    "Facility Type",
    "Utility Service",
    "Operating Status",
    "Operational Hours",
    "Address/Site Label",
    "Latitude",
    "Longitude",
    "Service Zone/Division",
    "Facility Manager",
    "Design Capacity (MLD)",
    "Commissioned Date",
    "Design Useful Life",
    "Annual O&M Budget",
    "Depreciation Schedule",
  ],
};

export const facilitiesTabDisplayNames: Record<string, string> = {
  facilityType: "Facility Type",
  utilityService: "Utility Service",
  operatingStatus: "Operating Status",
  operationalHours: "Operational Hours",
  serviceZone: "Service Zone/Division",
  facilityManager: "Facility Manager",
  depreciationSchedule: "Depreciation Schedule",
};

export const facilitiesTabDropdownOptions = (tabName: string) => {
  switch (tabName) {
    case "facilityType":
      return [
        { value: "treatment_plant", label: "Treatment Plant" },
        { value: "pumping_station", label: "Pumping Station" },
        { value: "reservoir", label: "Reservoir" },
        { value: "distribution_center", label: "Distribution Center" },
      ];
    case "utilityService":
      return [
        { value: "water", label: "Water" },
        { value: "wastewater", label: "Wastewater" },
        { value: "stormwater", label: "Stormwater" },
        { value: "electricity", label: "Electricity" },
      ];
    case "operatingStatus":
      return [
        { value: "operational", label: "Operational" },
        { value: "under_maintenance", label: "Under Maintenance" },
        { value: "non_operational", label: "Non-Operational" },
        { value: "planned", label: "Planned" },
      ];
    case "operationalHours":
      return [
        { value: "24_7", label: "24/7" },
        { value: "6am_10pm", label: "6 AM - 10 PM" },
        { value: "8_hours", label: "8 Hours/Day" },
        { value: "business_hours", label: "Business Hours" },
      ];
    case "serviceZone":
      return [
        { value: "north_zone", label: "North Zone" },
        { value: "south_zone", label: "South Zone" },
        { value: "east_zone", label: "East Zone" },
        { value: "west_zone", label: "West Zone" },
        { value: "central_division", label: "Central Division" },
      ];
    case "facilityManager":
      return [
        { value: "john_smith", label: "John Smith" },
        { value: "sarah_johnson", label: "Sarah Johnson" },
        { value: "michael_brown", label: "Michael Brown" },
      ];
    case "depreciationSchedule":
      return [
        { value: "straight_line", label: "Straight Line" },
        { value: "declining_balance", label: "Declining Balance" },
        { value: "units_of_production", label: "Units of Production" },
      ];
    default:
      return [];
  }
};
